import React from "react";
import person from "../img/person.png";
import location from "../img/location.png";
import organization from "../img/organization.png";
import property from "../img/property.png";
import {Card, Grid, List, NavBar, Picker, WhiteSpace, WingBlank} from "antd-mobile";

const Item = List.Item;

export default class EventInfo extends React.Component {

    render() {
        const {
            dailyList, selectIndex, event,
            selectDate,clickMention
        } = this.props;
        const data = dailyList.map((item, index) => {
            return {label: item, value: index}
        });

        const list = event.map((item, index) => {
            // const header = item['label'] + ' - ' + item['time'].substr(11);

            const entities = item['eventEntities'];

            let gridData = entities.map(item => {
                let icon;
                if (item['category'] === 'person') {
                    icon = person;
                } else if (item['category'] === 'location') {
                    icon = location;
                } else if (item['category'] === 'organization') {
                    icon = organization;
                } else {
                    icon = property;
                }
                return {icon: icon, text: item['mention']}
            });


            return <WingBlank key={'blank' + index} size={'lg'}>
                <WhiteSpace key={'space' + index} size={'lg'}/>
                <Card key={'card' + index}>
                    <Card.Header
                        title={item['label']}
                        extra={item['time'].substr(11)}
                    />
                    <Card.Body>
                        <Grid
                            key={index}
                            data={gridData}
                            square={true}
                            // isCarousel={true}
                            // carouselMaxRow={gridData.length > 4 ? 2 : 1}
                            hasLine={false}
                            itemStyle={{marginBottom: 10}}
                            onClick={clickMention}/>
                    </Card.Body>
                </Card>
            </WingBlank>
        });

        return <div>
            <NavBar
                mode="dark"
            >疫情日报</NavBar>
            <WhiteSpace size="lg"/>
            <Picker
                title={'请选择日期'}
                extra={dailyList[selectIndex]}
                data={data}
                cols={1}
                onChange={value => selectDate(value[0])}
                onOk={value => selectDate(value[0])}
            >
                <Item arrow="horizontal">日期</Item>
            </Picker>
            {list}
        </div>
    }
}
